import { render, staticRenderFns } from "./PrimarySchoolStudents.vue?vue&type=template&id=3b1f8e4c&scoped=true&"
import script from "./PrimarySchoolStudents.vue?vue&type=script&lang=js&"
export * from "./PrimarySchoolStudents.vue?vue&type=script&lang=js&"
import style0 from "./PrimarySchoolStudents.vue?vue&type=style&index=0&id=3b1f8e4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1f8e4c",
  null
  
)

export default component.exports